import gql from 'graphql-tag';

export default gql`
    query getAffiliate {
        affiliate {
            id
            name
            photo
            metadata {
                id
                name
                photo
            }
        }
    }
`;
